import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Select, Card, Row, Col, Button, Modal, Form, Input, List } from 'antd';
import { buildApiUrl } from '../config/api';
import '../styles/Common.css'; // 공통 스타일

const { Meta } = Card;
const { Option } = Select;
const { confirm } = Modal;

const ProductPeople = () => {
  const [options, setOptions] = useState([]);
  const [cards, setCards] = useState([]);
  const [selectedOption, setSelectedOption] = useState(undefined);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentEmployee, setCurrentEmployee] = useState(null);
  const [partOptions, setPartOptions] = useState([]);
  const [deletedEmployees, setDeletedEmployees] = useState([]);
  const [isDeletedModalVisible, setIsDeletedModalVisible] = useState(false);
  const [isRestoreModalVisible, setIsRestoreModalVisible] = useState(false);
  const [restorePart, setRestorePart] = useState(null);
  const [employeeToRestore, setEmployeeToRestore] = useState(null);
  const [restorePartError, setRestorePartError] = useState(false);
  const [isAdding, setIsAdding] = useState(false);
  const [formValid, setFormValid] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [response1, response2] = await Promise.all([
        axios.get(buildApiUrl('/api/partname')),
        axios.get(buildApiUrl('/api/employeelist'))
      ]);

      setOptions(response1.data);
      setPartOptions(response1.data);
      setCards(response2.data);
    } catch (error) {
      console.error('데이터를 가져오는 중 오류가 발생했습니다!', error);
    }
  };

  const handleOptionChange = (value) => {
    setSelectedOption(value);
  };

  const handleEdit = (employee) => {
    setCurrentEmployee(employee);
    setIsModalVisible(true);
    setIsAdding(false);
    validateForm(employee);
  };

  const handleAddEmployee = () => {
    const newEmployee = {
      Employee_Name: '',
      Employee_Rank: '',
      PartName: selectedOption || '',
    };
    setCurrentEmployee(newEmployee);
    setIsModalVisible(true);
    setIsAdding(true);
    validateForm(newEmployee);
  };

  const handleDelete = (employeeNo) => {
    confirm({
      title: '삭제하시겠습니까?',
      content: '삭제를 확인하시려면 확인 버튼을 눌러주세요.',
      okText: '확인',
      cancelText: '취소',
      onOk: () => {
        axios.post(buildApiUrl('/api/employee/delete'), { Employee_No: employeeNo })
          .then(() => {
            fetchData(); // 데이터 갱신
          })
          .catch(error => {
            console.error('직원을 삭제하는 중 오류가 발생했습니다!', error);
          });
      },
    });
  };

  const handleRestoreDeleted = () => {
    axios.get(buildApiUrl('/api/employeelist?partName=Delete'))
      .then(response => {
        setDeletedEmployees(response.data.filter(emp => emp.deleteDate));
        setIsDeletedModalVisible(true);
      })
      .catch(error => {
        console.error('삭제된 직원을 가져오는 중 오류가 발생했습니다!', error);
      });
  };

  const handleRestore = (employee) => {
    setEmployeeToRestore(employee);
    setIsRestoreModalVisible(true);
  };

  const handleRestoreModalOk = () => {
    if (!restorePart) {
      setRestorePartError(true);
      return;
    }

    if (employeeToRestore && restorePart) {
      const payload = {
        Employee_No: employeeToRestore.Employee_No,
        PartName: restorePart,
      };

      axios.post(buildApiUrl('/api/employee/restore'), payload)
        .then(response => {
          fetchData(); // 데이터 갱신
          setIsRestoreModalVisible(false);
        })
        .catch(error => {
          console.error('직원을 복구하는 중 오류가 발생했습니다!', error);
        });
    }
  };

  const handleRestoreModalCancel = () => {
    setIsRestoreModalVisible(false);
  };

  const handleModalOk = () => {
    const payload = {
      Employee_No: currentEmployee.Employee_No,
      Employee_Name: currentEmployee.Employee_Name,
      PartName: currentEmployee.PartName,
      Employee_Rank: currentEmployee.Employee_Rank,
      isStaff: currentEmployee.Employee_Rank === '아웃소싱' ? 0 : 1,
    };

    const apiEndpoint = isAdding 
      ? buildApiUrl('/api/employee/add') 
      : buildApiUrl('/api/employee/update');

    axios.post(apiEndpoint, payload)
      .then(response => {
        fetchData(); // 데이터 갱신
        setIsModalVisible(false);
      })
      .catch(error => {
        console.error(`직원을 ${isAdding ? '추가' : '수정'}하는 중 오류가 발생했습니다!`, error);
      });
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
  };

  const handleDeletedModalCancel = () => {
    setIsDeletedModalVisible(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const updatedEmployee = { ...currentEmployee, [name]: value };
    setCurrentEmployee(updatedEmployee);
    validateForm(updatedEmployee);
  };

  const handleSelectChange = (name, value) => {
    const updatedEmployee = { ...currentEmployee, [name]: value };
    setCurrentEmployee(updatedEmployee);
    validateForm(updatedEmployee);
  };

  const handleRestorePartChange = (value) => {
    setRestorePart(value);
    setRestorePartError(false);
  };

  const validateForm = (employee) => {
    const isValid = employee.Employee_Name && employee.Employee_Rank && employee.PartName;
    setFormValid(isValid);
  };

  const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hour = d.getHours();
    const minute = d.getMinutes();
    if (hour === 0 && minute === 0) {
      return `${year}년${month}월${day}일`;
    }
    const formattedHour = String(hour).padStart(2, '0');
    const formattedMinute = String(minute).padStart(2, '0');
    return `${year}년${month}월${day}일${formattedHour}시${formattedMinute}분`;
  };

  const filteredCards = cards
    .filter(card => card.PartName === selectedOption)
    .sort((a, b) => {
      const rankOrder = [
        '부장', '차장', '실장', '과장', '대리', '주임', '사원', '아웃소싱'
      ];
      const rankA = a.isStaff === 0 ? '아웃소싱' : a.Employee_Rank;
      const rankB = b.isStaff === 0 ? '아웃소싱' : b.Employee_Rank;
      return rankOrder.indexOf(rankA) - rankOrder.indexOf(rankB);
    });

  return (
    <div>
      <div className="common-container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <h2>인원 관리</h2>
          <Select
            value={selectedOption}
            onChange={handleOptionChange}
            style={{ width: '100%', maxWidth: 300, marginTop: 20 }}
            placeholder="파트를 선택하세요"
          >
            {options.map((option, index) => (
              <Option key={index} value={option.partNameEng}>{option.partNameKor}</Option>
            ))}
          </Select>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
          <Button type="primary" onClick={handleAddEmployee} style={{ backgroundColor: 'blue', marginBottom: 8 }}>
            인원 추가
          </Button>
          <Button type="primary" danger onClick={handleRestoreDeleted}>
            삭제된 인원 복구
          </Button>
        </div>
      </div>

      <div style={{ marginTop: 20 }}>
        <Row gutter={[16, 16]}>
          {filteredCards.map((card, index) => (
            <Col
              key={index}
              xs={24} sm={12} md={8} lg={6} xl={4}
            >
              <Card
                style={{ marginTop: 16 }}
                actions={[
                  <Button key="edit" type="link" style={{ color: 'blue' }} onClick={() => handleEdit(card)}>수정</Button>,
                  <Button key="delete" type="link" style={{ color: 'red' }} onClick={() => handleDelete(card.Employee_No)}>삭제</Button>,
                ]}
              >
                <Meta
                  title={card.Employee_Name}
                  description={`직책: ${card.isStaff === 0 ? '아웃소싱' : card.Employee_Rank}`}
                />
              </Card>
            </Col>
          ))}
        </Row>
      </div>

      <Modal 
        title="삭제된 인원 복구" 
        visible={isDeletedModalVisible} 
        onCancel={handleDeletedModalCancel}
        footer={null}
      >
        <List
          dataSource={deletedEmployees.filter(emp => emp.deleteDate && formatDate(emp.deleteDate))}
          renderItem={item => (
            <List.Item
              actions={[<Button type="link" onClick={() => handleRestore(item)}>복구</Button>]}
            >
              <div>
                <strong>{item.Employee_Name}</strong><br />
                <span>{formatDate(item.deleteDate)}</span>
              </div>
            </List.Item>
          )}
        />
      </Modal>

      <Modal 
        title="어느 파트로 복구하시겠습니까?" 
        visible={isRestoreModalVisible} 
        onOk={handleRestoreModalOk} 
        onCancel={handleRestoreModalCancel}
        okText="확인"
        cancelText="취소"
      >
        <div style={{ textAlign: 'center' }}>
          <Select
            style={{ width: '100%', maxWidth: 300 }}
            placeholder="파트를 선택하세요"
            onChange={handleRestorePartChange}
          >
            {partOptions.map((option, index) => (
              <Option key={index} value={option.partNameEng}>{option.partNameKor}</Option>
            ))}
          </Select>
          {restorePartError && <div style={{ color: 'red', marginTop: 8 }}>파트를 선택해야 합니다</div>}
        </div>
      </Modal>

      {currentEmployee && (
        <Modal 
          title={isAdding ? "인원 추가" : "직원 수정"} 
          visible={isModalVisible} 
          onOk={handleModalOk} 
          onCancel={handleModalCancel}
          okText="확인"
          cancelText="취소"
          okButtonProps={{ disabled: !formValid }}
        >
          <Form>
            <Form.Item label="이름">
              <Input name="Employee_Name" value={currentEmployee.Employee_Name} onChange={handleInputChange} />
            </Form.Item>
            <Form.Item label="직책">
              <Select name="Employee_Rank" value={currentEmployee.Employee_Rank} onChange={(value) => handleSelectChange('Employee_Rank', value)}>
                {['부장', '차장', '실장', '과장', '대리', '주임', '사원', '아웃소싱'].map(rank => (
                  <Option key={rank} value={rank}>{rank}</Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label="부서">
              <Select name="PartName" value={currentEmployee.PartName} onChange={(value) => handleSelectChange('PartName', value)}>
                {partOptions.map(part => (
                  <Option key={part.partNameEng} value={part.partNameEng}>{part.partNameKor}</Option>
                ))}
              </Select>
            </Form.Item>
          </Form>
        </Modal>
      )}
    </div>
  );
};

export default ProductPeople;
